__turbopack_context__.v({
  "className": "fira_code_c2cda48d-module__BkDHlq__className",
  "variable": "fira_code_c2cda48d-module__BkDHlq__variable",
});
